import http from "config/http";
import { ResponseWithParams, ResponseStatus } from "core/api/definitions";

export type ReportSubscribes = ResponseWithParams<ResponseStatus, any>;

export default async (actionSlug: string) => http.get(`/actions/reports/${actionSlug}/subscribes`);
